import { AbstractPinFactory } from "./AbstractPinFactory";

class CirclePinFactory extends AbstractPinFactory {
  constructor() {
    const shadow = `<filter id='shadow' color-interpolation-filters="sRGB" height="140%" width="140%" x="-20%">
    <feDropShadow dx="0" dy="2" stdDeviation="4" flood-opacity="0.2"/>
  </filter>`;

    super({
      originalWidth: 49.53,
      originalHeight: 54.66,
      shadowWidth: 10,
      shadowHeight: 10,
      desiredScaledWidth: 27,
      shadow: shadow,
      iconOffsetX: 0,
      iconOffsetY: -8,
    });
  }

  getPaths(color: string) {
    return `<path fill="white" filter="url(#shadow)" d="M42.278 7.25403C37.6002 2.57622 31.3806 0 24.765 0C18.1495 0 11.9299 2.57622 7.252 7.25403C2.57413 11.9321 0 18.1516 0 24.7671C0 36.187 7.8119 46.0798 18.765 48.8007C19.2318 48.9166 19.6513 49.1816 19.9399 49.5665L23.165 53.8667C23.965 54.9333 25.565 54.9333 26.365 53.8667L29.5902 49.5664C29.8789 49.1815 30.2983 48.9165 30.7652 48.8006C41.7203 46.0797 49.5322 36.187 49.5322 24.7671C49.5322 18.1516 46.9559 11.9321 42.278 7.25403Z"/>
            <circle cx="24.765" cy="25" r="22" fill="${color}"/>`;
  }
}

const circlePinFactory = new CirclePinFactory();
export { circlePinFactory };
